import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Button,
  Grid,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Checkbox,
  Td,
  HStack,
  Icon,
  VStack,
  Flex,
  SimpleGrid,
  useBreakpointValue,
  ButtonGroup,
  Tooltip,
  Select,
  Input,
  InputGroup,
  InputLeftElement,
  Divider,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useDisclosure,
  useToast,
  Fade,
  ScaleFade,
  SlideFade,
  Portal,
} from "@chakra-ui/react";
import {   
  AddIcon,
  ExternalLinkIcon,
  RepeatIcon,
  EditIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  DeleteIcon
} from '@chakra-ui/icons'
import {
  FiGrid,
  FiList,
  FiSearch,
  FiFilter,
  FiUsers,
  FiMail,
  FiCreditCard,
  FiSettings,
  FiEye,
  FiUserPlus,
  FiRefreshCw,
  FiDownload,
  FiChevronRight,
  FiCalendar,
  FiClipboard,
  FiAlertTriangle
} from 'react-icons/fi';
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { InfoCard } from "components/Card/EducationalCard.js";
import { AVATAR_GRADIENTS, getInitials, getCourseChipColors } from "utils/avatarStyles";
import ZoomableAvatar from "components/Avatar/ZoomableAvatar.js";
import { normalizeCourseName, codeToDisplayLabel, buildNormalizedGroupOptions, getUserGroups } from "utils/courseUtils";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useAppContext } from "../../../../context/appContext";
import BatchUsersOrderCreate from "./BatchUsersOrderCreate";
import BatchUsersTicketCreate from "./BatchUsersTicketCreate";
import BatchUsersOrderDelete from "./BatchUsersOrderDelete";
import BatchUsersOrderDuplicateFinder from "./BatchUsersOrderDuplicateFinder";
import BatchUsersGroup from "./BatchUsersGroup";
import BatchUsersSubscription from "./BatchUsersSubscription";
import BatchRoleModal from "./BatchRoleModal";
import PaymentAudit from "./PaymentAudit";
import BatchCarnetDownload from "./BatchCarnetDownload";
import { useModuleCheck, MODULES, getSiteConfig, useUserAuth, useRoleModuleAccess, canUserAccessCategory } from 'utils/site';
import { getAllSurveys } from "services/surveyService";
import ModalAddSurveyResponse from "components/Modal/ModalAddSurveyResponse";
import { getProducts, updateCustomer } from "services/woo";
import { updateApoderado, getUserByEmail } from "services/userService";
import { updateAdminUser } from "services/wpUsers";
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { format } from 'rut.js';

const Customers = ({
  title,
  customers,
  showActionsMenu = true,
  defaultAction = null, // 'tickets', 'group', 'subscription'
  onOpen, // Función para abrir modal de nuevo usuario
  loading = false, // Estado de carga
  onRefresh, // Función para actualizar datos
  totalCustomers = 0, // Total real (todas las páginas)
  onFetchAll = null, // Función para traer todos los customers filtrados
}) => {
  const history = useHistory();
  const toast = useToast();
  const { user: currentUser } = useUserAuth();
  const isAdmin = currentUser?.role === 'administrador';
  const hasAgenda = useRoleModuleAccess(MODULES.AGENDA);

  // DEBUG: Verificar datos recibidos por el componente
  React.useEffect(() => {
    if (customers && customers.length > 0) {
      console.log('🏠 CUSTOMERS COMPONENT: Datos recibidos:', customers.length, 'usuarios');
      console.log('🏠 CUSTOMERS COMPONENT: Primeros 3 usuarios:', customers.slice(0, 3).map(c => ({
        id: c.id,
        first_name: c.first_name,
        last_name: c.last_name,
        email: c.email,
        role: c.role,
        meta_data: c.meta_data?.map(m => ({ key: m.key, value: m.value }))
      })));
    }
  }, [customers]);
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
  
  // Estados existentes
  const [toogleOrderForm, setToogleOrderForm] = useState(false);
  const [toogleTicketForm, setToogleTicketForm] = useState(defaultAction === 'tickets');
  const [toogleCarnetForm, setToogleCarnetForm] = useState(false);
  const [toogleOrderDeleteForm, setToogleOrderDeleteForm] = useState(false);
  const [toogleDuplicateFinder, setToogleDuplicateFinder] = useState(false);
  const [toogleGroupForm, setToogleGroupForm] = useState(defaultAction === 'group');
  const [toogleSubscriptionForm, setToogleSubscriptionForm] = useState(defaultAction === 'subscription');
  const [toogleRoleForm, setToogleRoleForm] = useState(false);
  const [toogleAudit, setToogleAudit] = useState(false);

  // Todos los customers (todas las páginas) — se cargan al hacer "Seleccionar todos"
  const [allCustomers, setAllCustomers] = useState(null); // null = no cargado
  const [loadingAll, setLoadingAll] = useState(false);
  const [products, setProducts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: 'asc' });
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const lastCheckedIndexRef = useRef(null);

  // Nuevos estados para el diseño mejorado
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('customers-view-mode') || 'table');
  const [quickSearch, setQuickSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  // Responsive breakpoints
  const isMobile = useBreakpointValue({ base: true, md: false });
  const gridColumns = useBreakpointValue({ base: 1, sm: 2, md: 2, lg: 3, xl: 4 });

  // Estado de módulos - memoizado
  const moduleStatus = useMemo(() => ({
    [MODULES.PAYMENTS]: useModuleCheck(MODULES.PAYMENTS),
    [MODULES.TICKETS]: useModuleCheck(MODULES.TICKETS),
    [MODULES.SURVEYS]: useModuleCheck(MODULES.SURVEYS),
    [MODULES.FILES]: useModuleCheck(MODULES.FILES),
    [MODULES.SUBSCRIPTIONS]: useModuleCheck(MODULES.SUBSCRIPTIONS),
  }), []);

  // Formularios de "Ficha de atención" disponibles (para el dropdown de acción por fila)
  const [atencionForms, setAtencionForms] = useState([]);
  const [atencionTarget, setAtencionTarget] = useState(null); // { customer, survey }

  useEffect(() => {
    if (!moduleStatus[MODULES.SURVEYS] || !currentUser?.role) return;
    if (!canUserAccessCategory(currentUser.role, 'atencion')) return;

    const loadAtencionForms = async () => {
      try {
        const siteConfig = JSON.parse(getSiteConfig() || '{}');
        const glosario = {
          'Pagos CapitalWeb CL': 'pagos-capitalweb-cl',
          'Pagos BlasPascal CL': 'blaspascal',
          'Pagos Testing': 'blaspascal'
        };
        const siteSlug = glosario[siteConfig.name] || 'blaspascal';
        const surveys = await getAllSurveys(siteSlug, { userAuth: currentUser });
        setAtencionForms((surveys || []).filter(survey => survey.category === 'atencion'));
      } catch (error) {
        setAtencionForms([]);
      }
    };

    loadAtencionForms();
  }, [moduleStatus, currentUser]);

  // Filtrado y búsqueda
  const filteredCustomers = useMemo(() => {
    let filtered = customers;

    // Búsqueda rápida
    if (quickSearch) {
      filtered = filtered.filter(customer => 
        `${customer.first_name} ${customer.last_name}`.toLowerCase().includes(quickSearch.toLowerCase()) ||
        customer.email.toLowerCase().includes(quickSearch.toLowerCase()) ||
        customer.username.toLowerCase().includes(quickSearch.toLowerCase())
      );
    }

    // Filtro por estado
    if (statusFilter !== 'all') {
      filtered = filtered.filter(customer => customer.status === statusFilter);
    }

    return filtered;
  }, [customers, quickSearch, statusFilter]);

  // Estadísticas rápidas
  const stats = useMemo(() => ({
    total: customers.length,
    active: customers.filter(c => c.status === 'active').length,
    inactive: customers.filter(c => c.status === 'inactive').length,
    pending: customers.filter(c => c.status === 'pending').length,
    selected: selectedCustomers.length,
  }), [customers, selectedCustomers]);

  const handleSort = (column) => {
    setSortConfig(prevConfig => ({
      column,
      direction: prevConfig.column === column && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedCustomers(selectedIds);
  };

  const handleViewProfile = (customerId) => {
    // Abrir en nueva pestaña
    window.open(`${window.location.origin}/#/admin/usuario/${customerId}`, '_blank');
  };

  const handleRowClick = (customerId) => {
    // Navegar en la misma pestaña
    history.push(`/admin/usuario/${customerId}`);
  };

  const handleScheduleAppointment = (customer) => {
    if (!currentUser?.id || !customer.username) return;
    const url = `${window.location.origin}/#/public/reservar-hora/${currentUser.id}?student_rut=${encodeURIComponent(customer.username)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleEditCustomer = (customer) => {
    // Implementar edición de usuario
    setEditingCustomer(customer);
    setEditModalOpen(true);
    
    // Llenar el formulario con los datos del cliente
    setValue('first_name', customer.first_name);
    setValue('last_name', customer.last_name);
    setValue('email', customer.email);
    setValue('username', customer.username);
    
    // Obtener el grupo actual del cliente
    const currentGroup = customer.meta_data?.find(m => m.key === 'group_name')?.value || '';
    setValue('group', currentGroup);
    
    // Obtener la suscripción actual del cliente
    const currentSubscription = customer.meta_data?.find(m => m.key === 'suscription_name')?.value || '';
    setValue('suscription', currentSubscription);

    // Rol actual
    setValue('role', customer.role || 'customer');
  };

  const handleUpdateCustomer = async (data) => {
    setEditLoading(true);
    try {
      let laravelUpdateResult = { success: true }; // Default value for when module is inactive
      let laravelUserId = null;

      // 1. ACTUALIZACIÓN EN LARAVEL (automático si módulo activo)
      if (moduleStatus[MODULES.SURVEYS]) {
        try {
          // Buscar usuario en Laravel por email
          const existingUser = await getUserByEmail(data.email);
          
          if (existingUser && existingUser.id) {
            laravelUserId = existingUser.id;
            console.log(`[EDIT] Usuario encontrado en Laravel: ID=${existingUser.id}, Email=${data.email}`);
            
            // Actualizar usuario en Laravel
            const laravelData = {
              username: data.username,
              email: data.email,
              first_name: data.first_name,
              last_name: data.last_name,
            };

            laravelUpdateResult = await updateApoderado(laravelUserId, laravelData);
            console.log(`[EDIT] Resultado actualización Laravel:`, laravelUpdateResult);
            
            // Verificar si se sincronizó el respondent
            if (laravelUpdateResult.success && laravelUpdateResult.data?.respondent) {
              console.log(`[EDIT] Respondent sincronizado:`, laravelUpdateResult.data.respondent);
            }
          } else {
            console.log(`[EDIT] Usuario no encontrado en Laravel para email: ${data.email}`);
            laravelUpdateResult = { 
              success: true, 
              message: 'Usuario no existe en sistema de funcionalidades avanzadas' 
            };
          }
        } catch (laravelError) {
          console.error('[EDIT] Error en actualización Laravel:', laravelError);
          laravelUpdateResult = { 
            success: false, 
            message: `Error en sistema de funcionalidades avanzadas: ${laravelError.message || 'Error desconocido'}` 
          };
        }
      }

      // 2. ACTUALIZACIÓN EN WORDPRESS (siempre)
      const updateData = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        username: data.username,
        meta_data: [
          { key: 'group_name', value: data.group || '' }
        ]
      };

      // 2b. Cambio de rol (solo admin)
      if (isAdmin && data.role && data.role !== editingCustomer.role) {
        try {
          await updateAdminUser(editingCustomer.id, { role: data.role });
        } catch (roleErr) {
          console.error('[EDIT] Error al cambiar rol:', roleErr);
          toast({ title: 'Advertencia', description: 'Datos actualizados pero no se pudo cambiar el rol.', status: 'warning', duration: 4000, isClosable: true });
        }
      }

      const wordpressResult = await updateCustomer(editingCustomer.id, updateData);
      
      // 3. EVALUACIÓN DE RESULTADOS
      const bothSuccessful = laravelUpdateResult.success && wordpressResult.success;
      const atLeastOneSuccessful = laravelUpdateResult.success || wordpressResult.success;

      if (bothSuccessful) {
        // Ambos sistemas actualizados exitosamente
        let successMessage = "Usuario actualizado exitosamente en sistema CRM";
        if (moduleStatus[MODULES.SURVEYS] && laravelUserId) {
          successMessage += " y funcionalidades avanzadas";
          
          // Mencionar sincronización de respondent si ocurrió
          if (laravelUpdateResult.data?.respondent) {
            successMessage += " (incluyendo perfil de respondent)";
          }
        }

        toast({
          title: "Actualización completa",
          description: successMessage,
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        
        setEditModalOpen(false);
        setEditingCustomer(null);
        reset();
        if (onRefresh) {
          onRefresh();
        }
      } else if (atLeastOneSuccessful) {
        // Solo uno de los sistemas se actualizó
        const errors = [];
        if (!laravelUpdateResult.success) {
          errors.push(`Funcionalidades avanzadas: ${laravelUpdateResult.message}`);
        }
        if (!wordpressResult.success) {
          errors.push(`Sistema CRM: ${wordpressResult.message}`);
        }

        toast({
          title: "Actualización parcial",
          description: `Se actualizó parcialmente. Errores: ${errors.join(', ')}`,
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        
        // Si WordPress se actualizó, cerrar modal y actualizar
        if (wordpressResult.success) {
          setEditModalOpen(false);
          setEditingCustomer(null);
          reset();
          if (onRefresh) {
            onRefresh();
          }
        }
      } else {
        // Ambos sistemas fallaron
        const errors = [];
        if (!laravelUpdateResult.success) {
          errors.push(laravelUpdateResult.message);
        }
        if (!wordpressResult.success) {
          errors.push(wordpressResult.message);
        }

        toast({
          title: "Error al actualizar",
          description: `No se pudo actualizar: ${errors.join(', ')}`,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error updating customer:', error);
      toast({
        title: "Error",
        description: "Ocurrió un error inesperado al actualizar el usuario.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setEditLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditModalOpen(false);
    setEditingCustomer(null);
    reset();
  };

  useEffect(() => {
    getProducts().then(products => { setProducts(products) });
    const config = JSON.parse(getSiteConfig() || '{}');
    setGroups(config?.groups || []);

    // Cargar opciones de cursos normalizados para el modal de edición
    const loadCourseOptions = async () => {
      try {
        const rawGroups = await getUserGroups();
        const normalized = buildNormalizedGroupOptions(rawGroups);
        setCourseOptions(normalized.map(g => ({ value: g.rawValues[0], label: g.label })));
      } catch {
        const cfg = JSON.parse(getSiteConfig() || '{}');
        setCourseOptions((cfg?.groups || []).map(g => ({ value: g.name, label: g.name })));
      }
    };
    loadCourseOptions();
  }, [defaultAction]);


  // Convierte el group_name crudo de DB a etiqueta legible ("110:…" → "2° Básico A")
  const displayGroup = (raw) => {
    if (!raw) return null;
    return codeToDisplayLabel(normalizeCourseName(raw));
  };

  // Componente de controles principales
  const MainControls = () => (
    <Box bg="cream.bg" border="1px solid" borderColor="cream.line" borderRadius="14px" p={4} mb={2}>
      <Flex justify="space-between" align="center" wrap="wrap" gap={4}>

        <HStack spacing={3}>
          <Button
            size="sm"
            bg="coral.500"
            color="white"
            fontWeight="600"
            borderRadius="10px"
            _hover={{ bg: 'coral.600' }}
            _active={{ bg: 'coral.700' }}
            leftIcon={<Icon as={FiUserPlus} />}
            onClick={onOpen || (() => console.log('onOpen not provided'))}
          >
            Nuevo Usuario
          </Button>

          <Tooltip label="Actualizar lista">
            <IconButton
              icon={<Icon as={FiRefreshCw} />}
              size="sm"
              bg="cream.bg2"
              color="ink.700"
              borderRadius="10px"
              _hover={{ bg: 'coral.soft', color: 'coral.700' }}
              onClick={() => onRefresh ? onRefresh() : window.location.reload()}
              isLoading={loading}
            />
          </Tooltip>

          <ButtonGroup isAttached size="sm" spacing={0}>
            <Button
              bg={viewMode === 'table' ? 'coral.500' : 'cream.bg2'}
              color={viewMode === 'table' ? 'white' : 'ink.700'}
              borderRadius="10px 0 0 10px"
              _hover={{ bg: viewMode === 'table' ? 'coral.600' : 'coral.soft', color: viewMode === 'table' ? 'white' : 'coral.700' }}
              onClick={() => { setViewMode('table'); localStorage.setItem('customers-view-mode', 'table'); }}
              leftIcon={<Icon as={FiList} />}
            >
              {!isMobile && 'Tabla'}
            </Button>
            <Button
              bg={viewMode === 'grid' ? 'coral.500' : 'cream.bg2'}
              color={viewMode === 'grid' ? 'white' : 'ink.700'}
              borderRadius="0 10px 10px 0"
              _hover={{ bg: viewMode === 'grid' ? 'coral.600' : 'coral.soft', color: viewMode === 'grid' ? 'white' : 'coral.700' }}
              onClick={() => { setViewMode('grid'); localStorage.setItem('customers-view-mode', 'grid'); }}
              leftIcon={<Icon as={FiGrid} />}
            >
              {!isMobile && 'Tarjetas'}
            </Button>
          </ButtonGroup>
        </HStack>
      </Flex>
    </Box>
  );

  // Carga todos los customers de todas las páginas y los selecciona
  const handleSelectAll = async () => {
    if (!onFetchAll) return;
    setLoadingAll(true);
    try {
      const all = await onFetchAll();
      setAllCustomers(all);
      setSelectedCustomers(all.map(c => c.id));
    } finally {
      setLoadingAll(false);
    }
  };

  // Limpiar también resetea allCustomers
  const handleClearSelection = () => {
    setSelectedCustomers([]);
    setAllCustomers(null);
  };

  // Customers efectivos para acciones batch (todos o solo página actual)
  const effectiveCustomers = allCustomers || customers;

  // Estilo compartido para botones "ghost" del lenguaje cream/coral
  const ghostBtnProps = {
    bg: 'cream.bg2',
    color: 'ink.700',
    borderRadius: '10px',
    _hover: { bg: 'coral.soft', color: 'coral.700' },
  };

  // Componente de acciones masivas
  const BatchActions = () => {
    if (!showActionsMenu || selectedCustomers.length === 0) return null;

    const isAllPagesSelected = allCustomers !== null;

    return (
      <Box bg="coral.tint" border="1px solid" borderColor="coral.soft" p={4} borderRadius="14px" mb={4}>
        <HStack justify="space-between" wrap="wrap" spacing={4}>
          <HStack spacing={3}>
            <Icon as={FiUsers} color="coral.700" />
            <Text fontWeight="semibold" color="coral.700">
              {selectedCustomers.length} usuario{selectedCustomers.length !== 1 ? 's' : ''} seleccionado{selectedCustomers.length !== 1 ? 's' : ''}
              {isAllPagesSelected && (
                <Box as="span" ml={2} px="8px" py="2px" borderRadius="999px" fontSize="11px" fontWeight="700" bg="sky.bg" color="sky.ink">
                  todas las páginas
                </Box>
              )}
            </Text>
            {/* Botón para seleccionar TODOS los resultados (todas las páginas) */}
            {onFetchAll && !isAllPagesSelected && totalCustomers > customers.length && (
              <Button
                size="xs"
                variant="link"
                color="coral.700"
                onClick={handleSelectAll}
                isLoading={loadingAll}
                loadingText="Cargando..."
              >
                Seleccionar los {totalCustomers} resultados
              </Button>
            )}
          </HStack>
          
          <HStack spacing={2} wrap="wrap">
            {moduleStatus[MODULES.PAYMENTS] && (
              <Button
                size="sm"
                bg="coral.500"
                color="white"
                fontWeight="600"
                borderRadius="10px"
                _hover={{ bg: 'coral.600' }}
                _active={{ bg: 'coral.700' }}
                leftIcon={<Icon as={FiCreditCard} />}
                onClick={() => {
                  setToogleOrderForm(!toogleOrderForm);
                  setToogleOrderDeleteForm(false);
                  setToogleGroupForm(false);
                  setToogleTicketForm(false);
                  setToogleSubscriptionForm(false);
                  setToogleDuplicateFinder(false);
                }}
              >
                Cobrar
              </Button>
            )}

            {moduleStatus[MODULES.PAYMENTS] && (
              <Button
                size="sm"
                bg="transparent"
                border="1px solid"
                borderColor="danger.500"
                color="danger.500"
                borderRadius="10px"
                _hover={{ bg: 'danger.bg' }}
                leftIcon={<Icon as={DeleteIcon} />}
                onClick={() => {
                  setToogleOrderDeleteForm(!toogleOrderDeleteForm);
                  setToogleOrderForm(false);
                  setToogleGroupForm(false);
                  setToogleTicketForm(false);
                  setToogleSubscriptionForm(false);
                  setToogleDuplicateFinder(false);
                }}
              >
                Eliminar Cobro
              </Button>
            )}

            {moduleStatus[MODULES.PAYMENTS] && (
              <Button
                size="sm"
                bg="transparent"
                border="1px solid"
                borderColor="orange.400"
                color="orange.400"
                borderRadius="10px"
                _hover={{ bg: 'orange.50' }}
                leftIcon={<Icon as={FiAlertTriangle} />}
                onClick={() => {
                  setToogleDuplicateFinder(!toogleDuplicateFinder);
                  setToogleOrderForm(false);
                  setToogleOrderDeleteForm(false);
                  setToogleGroupForm(false);
                  setToogleTicketForm(false);
                  setToogleSubscriptionForm(false);
                }}
              >
                Duplicados
              </Button>
            )}

            {moduleStatus[MODULES.TICKETS] && (
              <Button
                size="sm"
                bg="mint.bg"
                color="mint.ink"
                fontWeight="600"
                borderRadius="10px"
                _hover={{ opacity: 0.85 }}
                leftIcon={<Icon as={AddIcon} />}
                onClick={() => {
                  setToogleTicketForm(!toogleTicketForm);
                  setToogleOrderDeleteForm(false);
                  setToogleOrderForm(false);
                  setToogleGroupForm(false);
                  setToogleSubscriptionForm(false);
                  setToogleDuplicateFinder(false);
                }}
              >
                Entradas
              </Button>
            )}

            <Button
              size="sm"
              {...ghostBtnProps}
              leftIcon={<Icon as={FiSettings} />}
              onClick={() => {
                setToogleGroupForm(!toogleGroupForm);
                setToogleOrderDeleteForm(false);
                setToogleOrderForm(false);
                setToogleTicketForm(false);
                setToogleSubscriptionForm(false);
                setToogleDuplicateFinder(false);
                setToogleRoleForm(false);
              }}
            >
              Cambiar Grupo
            </Button>

            {isAdmin && (
              <Button
                size="sm"
                {...ghostBtnProps}
                leftIcon={<Icon as={FiSettings} />}
                onClick={() => {
                  setToogleRoleForm(!toogleRoleForm);
                  setToogleGroupForm(false);
                  setToogleOrderDeleteForm(false);
                  setToogleOrderForm(false);
                  setToogleTicketForm(false);
                  setToogleSubscriptionForm(false);
                  setToogleDuplicateFinder(false);
                }}
              >
                Cambiar Rol
              </Button>
            )}

            {moduleStatus[MODULES.SUBSCRIPTIONS] && (
              <Button
                size="sm"
                {...ghostBtnProps}
                leftIcon={<Icon as={FiCreditCard} />}
                onClick={() => {
                  setToogleSubscriptionForm(!toogleSubscriptionForm);
                  setToogleOrderDeleteForm(false);
                  setToogleOrderForm(false);
                  setToogleTicketForm(false);
                  setToogleGroupForm(false);
                  setToogleDuplicateFinder(false);
                }}
              >
                Cambiar Mensualidad
              </Button>
            )}

            {moduleStatus[MODULES.PAYMENTS] && (
              <Button
                size="sm"
                bg="transparent"
                border="1px solid"
                borderColor="sky.ink"
                color="sky.ink"
                borderRadius="10px"
                _hover={{ bg: 'sky.bg' }}
                leftIcon={<Icon as={FiRefreshCw} />}
                onClick={() => setToogleAudit(true)}
              >
                Auditar Cobros
              </Button>
            )}

            <Button
              size="sm"
              bg="transparent"
              border="1px solid"
              borderColor="teal.ink"
              color="teal.ink"
              borderRadius="10px"
              _hover={{ bg: 'teal.bg' }}
              leftIcon={<Icon as={FiDownload} />}
              onClick={() => setToogleCarnetForm(true)}
            >
              Carnets ZIP
            </Button>

            <Button
              size="sm"
              {...ghostBtnProps}
              onClick={handleClearSelection}
            >
              Limpiar
            </Button>
          </HStack>
        </HStack>
      </Box>
    );
  };

  // Tarjeta vertical de alumno (estilo Datofy V1: card grid)
  const AlumnoCard = ({ customer, index }) => {
    const fullName = `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || 'Sin nombre';
    const group = customer.meta_data?.find(m => m.key === 'group_name')?.value;
    const groupLabel = displayGroup(group);
    const chipColors = getCourseChipColors(group);
    const hasAvatar = customer.meta_data?.some(m => m.key === 'avatar_url' && m.value);
    const avatarSrc = hasAvatar
      ? `${process.env.REACT_APP_SURVEY_API_URL}/api/users/${customer.username}/avatar-image`
      : null;
    const isSelected = selectedCustomers.includes(customer.id);

    return (
      <Box
        role="group"
        bg="cream.bg"
        border="1.5px solid"
        borderColor={isSelected ? 'coral.500' : 'cream.line'}
        borderRadius="16px"
        p="14px 12px 13px"
        cursor="pointer"
        onClick={() => handleRowClick(customer.id)}
        _hover={{ borderColor: 'coral.500', bg: 'coral.tint' }}
        transition="all 0.15s"
        fontFamily="jakarta"
      >
        {/* Fila superior: checkbox + flecha */}
        <Flex justify="space-between" align="center" mb="13px">
          <Box onClick={(e) => e.stopPropagation()}>
            <Checkbox
              isChecked={isSelected}
              onChange={(e) => {
                if (e.nativeEvent.shiftKey && lastCheckedIndexRef.current !== null) {
                  const start = Math.min(lastCheckedIndexRef.current, index);
                  const end = Math.max(lastCheckedIndexRef.current, index);
                  const rangeIds = filteredCustomers.slice(start, end + 1).map(c => c.id);
                  handleSelectionChange([...new Set([...selectedCustomers, ...rangeIds])]);
                } else {
                  const newSelected = isSelected
                    ? selectedCustomers.filter(id => id !== customer.id)
                    : [...selectedCustomers, customer.id];
                  handleSelectionChange(newSelected);
                }
                lastCheckedIndexRef.current = index;
              }}
            />
          </Box>
          <Icon as={FiChevronRight} boxSize="15px" color="ink.400" />
        </Flex>

        {/* Avatar centrado */}
        <Flex justify="center" mb="11px">
          {avatarSrc ? (
            <ZoomableAvatar src={avatarSrc} name={fullName} caption={{ firstName: customer.first_name, lastName: customer.last_name, rut: customer.username, course: groupLabel }} w="116px" h="116px" borderRadius="50%" />
          ) : (
            <Flex
              w="116px"
              h="116px"
              borderRadius="50%"
              bgGradient={AVATAR_GRADIENTS[index % AVATAR_GRADIENTS.length]}
              align="center"
              justify="center"
              fontWeight="700"
              color="white"
              fontSize="32px"
              flexShrink={0}
            >
              {getInitials(fullName)}
            </Flex>
          )}
        </Flex>

        {/* Nombre */}
        <Text fontWeight="700" fontSize="13.5px" letterSpacing="-0.01em" lineHeight="1.25" color="ink.900" textAlign="center" noOfLines={1}>
          {customer.first_name || fullName}
        </Text>
        {customer.last_name && (
          <Text fontWeight="700" fontSize="13.5px" letterSpacing="-0.01em" lineHeight="1.25" color="ink.900" textAlign="center" noOfLines={1} mb="3px">
            {customer.last_name}
          </Text>
        )}

        {/* RUT */}
        <Text fontSize="11.5px" color="ink.400" fontWeight="500" textAlign="center" noOfLines={1}>
          {customer.username}
        </Text>

        {/* Email */}
        {customer.email && (
          <Text fontSize="10.5px" color="ink.400" textAlign="center" noOfLines={1} mt="1px">
            {customer.email}
          </Text>
        )}

        {/* Chip de curso */}
        <Flex justify="center" mt="10px">
          {groupLabel ? (
            <Box
              as="span"
              px="10px"
              py="3px"
              borderRadius="999px"
              fontSize="11px"
              fontWeight="700"
              bg={chipColors.bg}
              color={chipColors.color}
            >
              {groupLabel}
            </Box>
          ) : (
            <Text fontSize="11px" color="ink.400">—</Text>
          )}
        </Flex>

        {/* Botones de acción */}
        {showActionsMenu && (
          <HStack
            spacing="5px"
            mt="11px"
            justify="center"
            opacity={isMobile ? 1 : 0}
            _groupHover={{ opacity: 1 }}
            transition="opacity 0.15s"
          >
            <ActionButton
              icon={EditIcon}
              label="Editar usuario"
              onClick={(e) => {
                e.stopPropagation();
                handleEditCustomer(customer);
              }}
            />
            {hasAgenda && currentUser?.id && (
              <ActionButton
                icon={FiCalendar}
                label="Agendar hora"
                onClick={(e) => {
                  e.stopPropagation();
                  handleScheduleAppointment(customer);
                }}
              />
            )}
            {atencionForms.length > 0 && (
              <AtencionFormMenu customer={customer} />
            )}
          </HStack>
        )}
      </Box>
    );
  };

  // Vista de Tarjetas
  const GridView = () => (
    <SimpleGrid
      columns={gridColumns}
      spacing="10px"
      maxHeight="600px"
      overflowY="auto"
      className="custom-scrollbar"
      pr={2}
    >
      {filteredCustomers.map((customer, index) => (
        <SlideFade key={customer.id} in={true} offsetY="20px" delay={index * 0.05}>
          <AlumnoCard customer={customer} index={index} />
        </SlideFade>
      ))}
    </SimpleGrid>
  );

  // Vista de Tabla mejorada (estilo Datofy V1: cream/coral)
  const ActionButton = ({ icon, label, onClick }) => (
    <Tooltip label={label}>
      <IconButton
        aria-label={label}
        icon={<Icon as={icon} boxSize="16px" />}
        onClick={onClick}
        w="34px"
        h="34px"
        minW="34px"
        borderRadius="9px"
        bg="cream.bg2"
        color="ink.700"
        _hover={{ bg: 'coral.soft', color: 'coral.700' }}
      />
    </Tooltip>
  );

  // Dropdown "Formulario de atención" — replica el patrón del menú "Formularios"
  // del perfil: lista todas las fichas de la categoría 'atencion' disponibles
  // y abre directamente la elegida para el alumno de esta fila.
  const AtencionFormMenu = ({ customer }) => (
    <Box onClick={(e) => e.stopPropagation()}>
      <Menu placement="bottom-end" isLazy>
        <Tooltip label="Formulario de atención">
          <MenuButton
            as={IconButton}
            aria-label="Formulario de atención"
            icon={<Icon as={FiClipboard} boxSize="16px" />}
            w="34px"
            h="34px"
            minW="34px"
            borderRadius="9px"
            bg="cream.bg2"
            color="ink.700"
            _hover={{ bg: 'coral.soft', color: 'coral.700' }}
          />
        </Tooltip>
        <Portal>
          <MenuList zIndex="popover" fontSize="13px" minW="220px" maxW="280px">
            {atencionForms.map((survey) => (
              <MenuItem
                key={survey.id}
                onClick={() => setAtencionTarget({ customer, survey })}
              >
                <VStack align="flex-start" spacing={0}>
                  <Text fontWeight="600" fontSize="13px">{survey.name}</Text>
                  {survey.description && (
                    <Text fontSize="11px" color="ink.400" noOfLines={1}>{survey.description}</Text>
                  )}
                </VStack>
              </MenuItem>
            ))}
          </MenuList>
        </Portal>
      </Menu>
    </Box>
  );

  const tableHeaderProps = {
    border: "none",
    color: "ink.400",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    py: "13px",
    px: "16px"
  };

  const TableView = () => (
    <Box
      maxW={{ base: "calc(100vw - 30px)", xl: "calc(100vw - 300px)" }}
      overflowX="auto"
      overflowY={{ base: "hidden", md: "auto" }}
      maxHeight={{ base: "none", md: "600px" }}
      borderRadius="22px"
      bg="white"
      boxShadow="0px 3.5px 5.5px rgba(0,0,0,0.02)"
      fontFamily="jakarta"
      className="custom-scrollbar"
      sx={{ WebkitOverflowScrolling: 'touch' }}
    >
        <Table
          variant="simple"
          layout="fixed"
          width="100%"
          minWidth="800px"
        >
          <Thead
            bg="cream.bg2"
            position="sticky"
            top="0"
            zIndex="1"
          >
            <Tr>
              <Th {...tableHeaderProps} width="40px">
                <Checkbox
                  isChecked={selectedCustomers.length === filteredCustomers.length && filteredCustomers.length > 0}
                  isIndeterminate={selectedCustomers.length > 0 && selectedCustomers.length < filteredCustomers.length}
                  onChange={(e) => handleSelectionChange(
                    e.target.checked ? filteredCustomers.map(c => c.id) : []
                  )}
                />
              </Th>
              <Th
                {...tableHeaderProps}
                cursor="pointer"
                onClick={() => handleSort('name')}
                width="26%"
                minWidth="200px"
              >
                <HStack spacing={2}>
                  <Text>Alumno</Text>
                  <Icon
                    as={sortConfig.column === 'name' ?
                      (sortConfig.direction === 'asc' ? ChevronUpIcon : ChevronDownIcon) :
                      ChevronUpIcon
                    }
                  />
                </HStack>
              </Th>
              <Th {...tableHeaderProps} width="24%" minWidth="170px">
                Apoderado
              </Th>
              <Th {...tableHeaderProps} width="18%" minWidth="130px">
                Curso
              </Th>
              <Th {...tableHeaderProps} width="14%" minWidth="100px">
                Ingreso
              </Th>
              <Th {...tableHeaderProps} width="160px" minWidth="150px">
                Acciones
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredCustomers.map((customer, index) => {
              const fullName = `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || 'Sin nombre';
              const apoderadoNombre = customer.meta_data?.find(m => m.key === 'apoderado_nombre')?.value || fullName;
              const apoderadoEmail = customer.meta_data?.find(m => m.key === 'apoderado_email')?.value || customer.email;
              const group = customer.meta_data?.find(m => m.key === 'group_name')?.value;
              const groupLabel = displayGroup(group);
              const chipColors = getCourseChipColors(group);
              const hasAvatar = customer.meta_data?.some(m => m.key === 'avatar_url' && m.value);
              const avatarSrc = hasAvatar
                ? `${process.env.REACT_APP_SURVEY_API_URL}/api/users/${customer.username}/avatar-image`
                : null;
              const ingreso = customer.date_created
                ? new Intl.DateTimeFormat('es-CL', { month: 'short', year: 'numeric' }).format(new Date(customer.date_created))
                : '—';

              return (
                  <Tr
                    key={customer.id}
                    borderTop="1px solid"
                    borderColor="cream.line"
                    _hover={{ bg: 'coral.tint' }}
                    transition="background 0.13s"
                  >
                    <Td px="16px" py="14px" width="40px" border="none">
                      <Checkbox
                        isChecked={selectedCustomers.includes(customer.id)}
                        onChange={(e) => {
                          if (e.nativeEvent.shiftKey && lastCheckedIndexRef.current !== null) {
                            const start = Math.min(lastCheckedIndexRef.current, index);
                            const end = Math.max(lastCheckedIndexRef.current, index);
                            const rangeIds = filteredCustomers.slice(start, end + 1).map(c => c.id);
                            handleSelectionChange([...new Set([...selectedCustomers, ...rangeIds])]);
                          } else {
                            const newSelected = selectedCustomers.includes(customer.id)
                              ? selectedCustomers.filter(id => id !== customer.id)
                              : [...selectedCustomers, customer.id];
                            handleSelectionChange(newSelected);
                          }
                          lastCheckedIndexRef.current = index;
                        }}
                      />
                    </Td>
                    <Td
                      px="16px"
                      py="14px"
                      cursor="pointer"
                      onClick={() => handleRowClick(customer.id)}
                      width="26%"
                      minWidth="200px"
                      border="none"
                    >
                      <Flex align="center" gap="12px" minW={0}>
                        {avatarSrc ? (
                          <ZoomableAvatar src={avatarSrc} name={fullName} caption={{ firstName: customer.first_name, lastName: customer.last_name, rut: customer.username, course: groupLabel }} w="40px" h="40px" borderRadius="50%" flexShrink={0} />
                        ) : (
                          <Flex
                            w="40px"
                            h="40px"
                            borderRadius="50%"
                            bgGradient={AVATAR_GRADIENTS[index % AVATAR_GRADIENTS.length]}
                            align="center"
                            justify="center"
                            fontWeight="700"
                            color="white"
                            fontSize="13px"
                            flexShrink={0}
                          >
                            {getInitials(fullName)}
                          </Flex>
                        )}
                        <Box minW={0}>
                          <Text fontWeight="700" fontSize="14.5px" letterSpacing="-0.01em" lineHeight="1.2" color="ink.900" noOfLines={1}>
                            {customer.first_name || fullName}
                          </Text>
                          {customer.last_name && (
                            <Text fontWeight="700" fontSize="14.5px" letterSpacing="-0.01em" lineHeight="1.2" color="ink.900" mt="2px" noOfLines={1}>
                              {customer.last_name}
                            </Text>
                          )}
                          <Text fontSize="12px" color="ink.400" fontWeight="500" mt="2px" noOfLines={1}>
                            RUT {customer.username}
                          </Text>
                        </Box>
                      </Flex>
                    </Td>
                    <Td
                      px="16px"
                      py="14px"
                      cursor="pointer"
                      onClick={() => handleRowClick(customer.id)}
                      width="24%"
                      minWidth="170px"
                      border="none"
                    >
                      <Box minW={0}>
                        <Text fontSize="13px" color="ink.700" fontWeight="500" lineHeight="1.3" noOfLines={1}>
                          {apoderadoNombre}
                        </Text>
                        <Text fontSize="11.5px" color="ink.400" noOfLines={1}>
                          {apoderadoEmail}
                        </Text>
                      </Box>
                    </Td>
                    <Td
                      px="16px"
                      py="14px"
                      cursor="pointer"
                      onClick={() => handleRowClick(customer.id)}
                      width="18%"
                      minWidth="130px"
                      border="none"
                    >
                      {groupLabel ? (
                        <Box
                          as="span"
                          display="inline-flex"
                          alignItems="center"
                          px="11px"
                          py="4px"
                          borderRadius="999px"
                          fontSize="12px"
                          fontWeight="700"
                          bg={chipColors.bg}
                          color={chipColors.color}
                        >
                          {groupLabel}
                        </Box>
                      ) : (
                        <Text fontSize="13px" color="ink.400">—</Text>
                      )}
                    </Td>
                    <Td
                      px="16px"
                      py="14px"
                      cursor="pointer"
                      onClick={() => handleRowClick(customer.id)}
                      width="14%"
                      minWidth="100px"
                      border="none"
                    >
                      <Text fontSize="13px" color="ink.400" fontWeight="600">
                        {ingreso}
                      </Text>
                    </Td>
                    <Td px="16px" py="14px" width="160px" minWidth="150px" border="none">
                      <HStack spacing="6px">
                        <ActionButton
                          icon={FiEye}
                          label="Ver perfil"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewProfile(customer.id);
                          }}
                        />
                        <ActionButton
                          icon={EditIcon}
                          label="Editar usuario"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditCustomer(customer);
                          }}
                        />
                        {hasAgenda && currentUser?.id && (
                          <ActionButton
                            icon={FiCalendar}
                            label="Agendar hora"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleScheduleAppointment(customer);
                            }}
                          />
                        )}
                        {atencionForms.length > 0 && (
                          <AtencionFormMenu customer={customer} />
                        )}
                      </HStack>
                    </Td>
                  </Tr>
              );
            })}
          </Tbody>
        </Table>
    </Box>
  );

  return (
    <VStack align="stretch" spacing={6}>

      {/* Controles principales */}
      <MainControls />

      {/* Acciones masivas */}
      <BatchActions />

      {/* Formularios de acciones masivas */}
      {/* Modal para crear entradas */}
      {moduleStatus[MODULES.TICKETS] && (
        <Modal isOpen={toogleTicketForm} onClose={() => setToogleTicketForm(false)} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Crear Entradas</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <BatchUsersTicketCreate 
                customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
                categoryId={'tickets'} 
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      
      {/* Modal para nuevo cobro */}
      {moduleStatus[MODULES.PAYMENTS] && (
        <Modal isOpen={toogleOrderForm} onClose={() => setToogleOrderForm(false)} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Generar Nuevo Cobro</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <BatchUsersOrderCreate 
                customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
                productsList={products} 
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      
      {/* Modal para eliminar cobro */}
      {moduleStatus[MODULES.PAYMENTS] && (
        <Modal isOpen={toogleOrderDeleteForm} onClose={() => setToogleOrderDeleteForm(false)} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Eliminar Cobros</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <BatchUsersOrderDelete 
                customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
                productsList={products} 
                title={"Buscar la mensualidad que quieres eliminar"} 
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      {/* Modal para buscar órdenes duplicadas */}
      {moduleStatus[MODULES.PAYMENTS] && (
        <Modal isOpen={toogleDuplicateFinder} onClose={() => setToogleDuplicateFinder(false)} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Buscar Órdenes Duplicadas</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <BatchUsersOrderDuplicateFinder 
                customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
                title={"Buscar y limpiar órdenes de mensualidad duplicadas"} 
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      {/* Modal para cambio de grupo */}
      <Modal isOpen={toogleGroupForm} onClose={() => setToogleGroupForm(false)} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cambiar Grupo de Usuarios</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersGroup 
              customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
              groupList={groups} 
              title={"Mover los usuarios seleccionados a un nuevo grupo"} 
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      
      {/* Modal para cambio de suscripción */}
      {moduleStatus[MODULES.SUBSCRIPTIONS] && (
        <Modal isOpen={toogleSubscriptionForm} onClose={() => setToogleSubscriptionForm(false)} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Cambiar Mensualidad de Usuarios</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <BatchUsersSubscription 
                customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))} 
                onSubscriptionChanged={() => {
                  setToogleSubscriptionForm(false);
                  if (onRefresh) onRefresh();
                }}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      
      {/* Modal para cambio masivo de rol (solo admin) */}
      {isAdmin && (
        <BatchRoleModal
          isOpen={toogleRoleForm}
          onClose={() => setToogleRoleForm(false)}
          customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))}
          onDone={() => { setToogleRoleForm(false); if (onRefresh) onRefresh(); }}
        />
      )}

      {/* Modal Auditar Cobros — escanea TODOS los usuarios filtrados */}
      {moduleStatus[MODULES.PAYMENTS] && (
        <Modal isOpen={toogleAudit} onClose={() => setToogleAudit(false)} size="6xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              Auditar Cobros — {totalCustomers > customers.length ? totalCustomers : customers.length} usuarios filtrados
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <PaymentAudit
                customers={customers}
                onFetchAll={onFetchAll}
                totalCustomers={totalCustomers}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      {/* Modal Carnets ZIP */}
      {toogleCarnetForm && (
        <BatchCarnetDownload
          customers={effectiveCustomers.filter(c => selectedCustomers.includes(c.id))}
          onClose={() => setToogleCarnetForm(false)}
        />
      )}

      {/* Contenido principal */}
      {filteredCustomers.length === 0 ? (
        <InfoCard title="No se encontraron usuarios" icon={FiUsers}>
          <VStack spacing={4} py={8}>
            <Text color="ink.400" textAlign="center">
              No hay usuarios que coincidan con los filtros seleccionados.
            </Text>
            <Button
              bg="coral.500"
              color="white"
              fontWeight="600"
              borderRadius="10px"
              _hover={{ bg: 'coral.600' }}
              _active={{ bg: 'coral.700' }}
              onClick={() => {
                setQuickSearch('');
                setStatusFilter('all');
              }}
            >
              Limpiar filtros
            </Button>
          </VStack>
        </InfoCard>
      ) : (
        viewMode === 'grid' ? GridView() : TableView()
      )}

      {/* Modal de edición de usuario */}
      <Modal isOpen={editModalOpen} onClose={handleCancelEdit} size="lg">
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(handleUpdateCustomer)}>
            <ModalHeader>Editar Usuario</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl isRequired>
                <FormLabel>RUT</FormLabel>
                <Input
                  {...register("username", { required: "El RUT es requerido" })}
                  onChange={(e) => {
                    const formattedValue = format(e.target.value, { dots: false });
                    setValue("username", formattedValue);
                  }}
                  placeholder="Ejemplo: 12345678-9"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  {...register("email", { 
                    required: "El email es requerido",
                    pattern: { value: /^\S+@\S+$/i, message: "Email inválido" }
                  })}
                  placeholder="email@ejemplo.com"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Nombres</FormLabel>
                <Input
                  {...register("first_name", { required: "Los nombres son requeridos" })}
                  placeholder="Nombres"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Apellidos</FormLabel>
                <Input
                  {...register("last_name", { required: "Los apellidos son requeridos" })}
                  placeholder="Apellidos"
                />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Curso</FormLabel>
                <Select {...register("group")} placeholder="Seleccionar curso">
                  <option value="">Sin curso</option>
                  {courseOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {moduleStatus[MODULES.SUBSCRIPTIONS] && (
                <FormControl mt={4}>
                  <FormLabel>Mensualidad</FormLabel>
                  <Select {...register("suscription")} placeholder="Seleccione una mensualidad">
                    <option value="">Sin suscripción</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.name}>
                        {product.name} - ${product.price}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}

              {isAdmin && (
                <FormControl mt={4}>
                  <FormLabel>Rol</FormLabel>
                  <Select {...register("role")}>
                    <option value="customer">Activo (customer)</option>
                    <option value="becado">Becado</option>
                    <option value="cobranza">Cobranza</option>
                    <option value="subscriber">Archivado (subscriber)</option>
                  </Select>
                </FormControl>
              )}
            </ModalBody>

            <ModalFooter>
              <Button
                bg="coral.500"
                color="white"
                fontWeight="600"
                borderRadius="10px"
                _hover={{ bg: 'coral.600' }}
                _active={{ bg: 'coral.700' }}
                mr={3}
                type="submit"
                isLoading={editLoading}
              >
                Actualizar
              </Button>
              <Button {...ghostBtnProps} onClick={handleCancelEdit}>
                Cancelar
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* Modal de Ficha de Atención - acceso directo desde el listado */}
      {atencionTarget && (
        <ModalAddSurveyResponse
          isOpen={!!atencionTarget}
          onClose={() => setAtencionTarget(null)}
          customer={atencionTarget.customer}
          updateSurveyResponses={() => setAtencionTarget(null)}
          directAccess={{ id: atencionTarget.survey.id, slug: atencionTarget.survey.slug }}
        />
      )}

    </VStack>
  );
};

export default Customers;